import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawSchoologyIcon from "./RawSchoologyIcon.svg.jsx";

const SchoologyIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawSchoologyIcon} {...props} />;
});

export default SchoologyIcon;
